module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-7108ab1c.png";